import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { retrieveTokensAndSetCookies } from './token_extraction';

export function isRoutePathInV3Routes(toRoute: string): boolean {
  return toRoute !== '/forms' && !toRoute.startsWith('/forms/');
}

interface RedirectionOutput {
  shouldRedirect: boolean;
  isDevMode: boolean;
  isV3Route: boolean;
}

// Returns a boolean if the route is included in the vue3Routes list.
// This function can parse and use a full route or partial routes, so long
// as the navigation to route starts with the Vue 3 route.
// e.g. /wfm/hr will return true for /wfm/hr and /wfm/hr/employees
export function shouldRedirectToV2(toRoute: string): RedirectionOutput {
  const isDevMode = isDevelopmentMode();
  const isV3Route = isRoutePathInV3Routes(toRoute);

  let shouldRedirect = !isV3Route;

  if (isDevMode) shouldRedirect = false;

  return {
    shouldRedirect,
    isDevMode,
    isV3Route,
    // For testing redirects
    // shouldRedirect: true,
  };
}

function addBaseRoute(toRoute: string) {
  const baseRoute = import.meta.env.BASE_URL;

  if (baseRoute === '/') {
    return toRoute;
  }

  return `${baseRoute}${toRoute}`;
}

export function redirectToV2App(path: string) {
  const isStaging =
    window.location.host === 'staging-v3.myqsrsoft.com' ||
    window.location.host === 'staging.myqsrsoft.com';
  const isDev =
    window.location.host === 'dev-v3.myqsrsoft.com' ||
    window.location.host === 'dev.myqsrsoft.com';

  let domain = 'https://home.myqsrsoft.com';
  if (isStaging) domain = 'https://staging.myqsrsoft.com';
  if (isDev) domain = 'https://dev.myqsrsoft.com';

  let fullPath = path;
  if (fullPath.charAt(0) !== '/') {
    fullPath = `/${fullPath}`;
  }
  console.log('Redirecting to V2', `${domain}${fullPath}`, path);
  window.location.href = `${domain}${fullPath}`;
}

export function isDevelopmentMode(): boolean {
  const isBeta = window.location.host === 'beta-v3.myqsrsoft.com';
  // const isStaging = window.location.host === 'staging-v3.myqsrsoft.com';
  // const isDev = window.location.host === 'dev-v3.myqsrsoft.com';

  const nonRegularHosts = isBeta; // || isDev;

  return import.meta.env.DEV || nonRegularHosts;
}

export async function v2RedirectionNavGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) {
  if (!to.path || !from.path) {
    next();
    return;
  }

  if (to.path === from.path) {
    next();
    return;
  }

  const result = shouldRedirectToV2(to.path);

  if (result.shouldRedirect) {
    try {
      await retrieveTokensAndSetCookies();

      const toRoute = to.fullPath ?? to.path;
      const toRoutePlusBase = addBaseRoute(toRoute);

      redirectToV2App(toRoutePlusBase);
    } catch (e) {
      //
      console.error(e);
    }
  }
  next();
}
